import { commonHelpers } from 'helpers/commonHelper';
import { getTableHeightFitContent } from 'helpers/lib/reactDataGridHelpers';
import { get } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import ReactDataGrid from 'react-data-grid';

const EmptyRowsView = () => {
    const message = 'Chưa có mục chi nào';
    return (
        <div style={{ textAlign: 'center', backgroundColor: '#ddd', padding: '100px' }}>
            <h3>{message}</h3>
        </div>
    );
};

function DuChiCaNhanTable({ academicYear, duchicanhans, danhmucduchicanhans, data, setData }) {
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);

    const numOfMonthForYear = get(academicYear, 'congDoanNumOfMonth', 12);

    const [tableHeight, setTableHeight] = useState();
    useEffect(() => {
        setTableHeight(getTableHeightFitContent());
    }, []);

    useEffect(() => {
        const rows = [];
        if (danhmucduchicanhans) {
            danhmucduchicanhans.forEach((dm) => {
                const matchedDuChiCaNhan = duchicanhans ? duchicanhans.find((duchi) => dm.code === duchi.danhMucChiCongDoanCode) : {};
                const row = {
                    dmId: dm.id,
                    code: dm.code,
                    name: dm.name,
                    id: get(matchedDuChiCaNhan, 'id'),
                    danhMucChiCongDoanCode: get(matchedDuChiCaNhan, 'danhMucChiCongDoanCode'),
                    junAmount: get(matchedDuChiCaNhan, 'junAmount', '') ? get(matchedDuChiCaNhan, 'junAmount', '') : '',
                    julAmount: get(matchedDuChiCaNhan, 'julAmount', '') ? get(matchedDuChiCaNhan, 'julAmount', '') : '',
                    augAmount: get(matchedDuChiCaNhan, 'augAmount', '') ? get(matchedDuChiCaNhan, 'augAmount', '') : '',
                    sepAmount: get(matchedDuChiCaNhan, 'sepAmount', '') ? get(matchedDuChiCaNhan, 'sepAmount', '') : '',
                    octAmount: get(matchedDuChiCaNhan, 'octAmount', '') ? get(matchedDuChiCaNhan, 'octAmount', '') : '',
                    novAmount: get(matchedDuChiCaNhan, 'novAmount', '') ? get(matchedDuChiCaNhan, 'novAmount', '') : '',
                    decAmount: get(matchedDuChiCaNhan, 'decAmount', '') ? get(matchedDuChiCaNhan, 'decAmount', '') : '',
                    janAmount: get(matchedDuChiCaNhan, 'janAmount', '') ? get(matchedDuChiCaNhan, 'janAmount', '') : '',
                    febAmount: get(matchedDuChiCaNhan, 'febAmount', '') ? get(matchedDuChiCaNhan, 'febAmount', '') : '',
                    marAmount: get(matchedDuChiCaNhan, 'marAmount', '') ? get(matchedDuChiCaNhan, 'marAmount', '') : '',
                    aprAmount: get(matchedDuChiCaNhan, 'aprAmount', '') ? get(matchedDuChiCaNhan, 'aprAmount', '') : '',
                    mayAmount: get(matchedDuChiCaNhan, 'mayAmount', '') ? get(matchedDuChiCaNhan, 'mayAmount', '') : '',
                    extraAmount1: get(matchedDuChiCaNhan, 'extraAmount1', '') ? get(matchedDuChiCaNhan, 'extraAmount1', '') : '',
                    extraAmount2: get(matchedDuChiCaNhan, 'extraAmount2', '') ? get(matchedDuChiCaNhan, 'extraAmount2', '') : '',
                    duchi: matchedDuChiCaNhan,
                };
                rows.push(row);
            });
            setRows(rows);
        }
    }, [duchicanhans, danhmucduchicanhans]);

    const buildDynamicColumnBaseOnYear = useCallback(() => {
        const isEditable = commonHelpers.ableToPersitDuThuChi(academicYear.name);
        if (numOfMonthForYear === 14) {
            return [
                { key: 'aprAmount', name: 'Tháng 4', editable: isEditable, width: 80 },
                { key: 'mayAmount', name: 'Tháng 5', editable: isEditable, width: 80 },
                { key: 'junAmount', name: 'Tháng 6', editable: isEditable, width: 80 },
                { key: 'julAmount', name: 'Tháng 7', editable: isEditable, width: 80 },
                { key: 'augAmount', name: 'Tháng 8', editable: isEditable, width: 80 },
                { key: 'sepAmount', name: 'Tháng 9', editable: isEditable, width: 80 },
                { key: 'octAmount', name: 'Tháng 10', editable: isEditable, width: 80 },
                { key: 'novAmount', name: 'Tháng 11', editable: isEditable, width: 80 },
                { key: 'decAmount', name: 'Tháng 12', editable: isEditable, width: 80 },
                { key: 'janAmount', name: 'Tháng 1', editable: isEditable, width: 80 },
                { key: 'febAmount', name: 'Tháng 2', editable: isEditable, width: 80 },
                { key: 'marAmount', name: 'Tháng 3', editable: isEditable, width: 80 },
                { key: 'extraAmount1', name: 'Tháng 4', editable: isEditable, width: 80 },
                { key: 'extraAmount2', name: 'Tháng 5', editable: isEditable, width: 80 },
            ];
        } else if (numOfMonthForYear === 10) {
            return [
                { key: 'junAmount', name: 'Tháng 6', editable: isEditable, width: 80 },
                { key: 'julAmount', name: 'Tháng 7', editable: isEditable, width: 80 },
                { key: 'augAmount', name: 'Tháng 8', editable: isEditable, width: 80 },
                { key: 'sepAmount', name: 'Tháng 9', editable: isEditable, width: 80 },
                { key: 'octAmount', name: 'Tháng 10', editable: isEditable, width: 80 },
                { key: 'novAmount', name: 'Tháng 11', editable: isEditable, width: 80 },
                { key: 'decAmount', name: 'Tháng 12', editable: isEditable, width: 80 },
                { key: 'janAmount', name: 'Tháng 1', editable: isEditable, width: 80 },
                { key: 'febAmount', name: 'Tháng 2', editable: isEditable, width: 80 },
                { key: 'marAmount', name: 'Tháng 3', editable: isEditable, width: 80 },
            ];
        } else {
            return [
                { key: 'junAmount', name: 'Tháng 6', editable: isEditable, width: 80 },
                { key: 'julAmount', name: 'Tháng 7', editable: isEditable, width: 80 },
                { key: 'augAmount', name: 'Tháng 8', editable: isEditable, width: 80 },
                { key: 'sepAmount', name: 'Tháng 9', editable: isEditable, width: 80 },
                { key: 'octAmount', name: 'Tháng 10', editable: isEditable, width: 80 },
                { key: 'novAmount', name: 'Tháng 11', editable: isEditable, width: 80 },
                { key: 'decAmount', name: 'Tháng 12', editable: isEditable, width: 80 },
                { key: 'janAmount', name: 'Tháng 1', editable: isEditable, width: 80 },
                { key: 'febAmount', name: 'Tháng 2', editable: isEditable, width: 80 },
                { key: 'marAmount', name: 'Tháng 3', editable: isEditable, width: 80 },
                { key: 'aprAmount', name: 'Tháng 4', editable: isEditable, width: 80 },
                { key: 'mayAmount', name: 'Tháng 5', editable: isEditable, width: 80 },
            ];
        }
    }, [numOfMonthForYear]);

    useEffect(() => {
        const commonColumns = [
            { key: 'code', name: 'Mã số', editable: false, width: 60 },
            { key: 'name', name: 'Diễn giải', editable: false, width: 360 },
        ];
        const dynamicColumns = buildDynamicColumnBaseOnYear();
        const columns = [...commonColumns, ...dynamicColumns].map((item) => {
            return { ...item, ...{ resizable: true } };
        });
        setColumns(columns);
    }, [buildDynamicColumnBaseOnYear]);

    const onGridRowsUpdated = ({ fromRow, toRow, updated, cellKey }) => {
        const newData = new Map(data);
        const newRows = [...rows];
        for (let i = fromRow; i <= toRow; i++) {
            newRows[i] = { ...newRows[i], ...updated };
            if (get(newRows[i], 'dm.id', false) || updated[cellKey] !== '') {
                newData.set(i, newRows[i]);
            }
        }
        setRows(newRows);
        setData(newRows);
    };

    return (
        <div id="rdg">
            <ReactDataGrid
                columns={columns}
                rowGetter={(i) => rows[i]}
                rowsCount={rows.length}
                minHeight={tableHeight}
                enableCellSelect={true}
                onGridRowsUpdated={onGridRowsUpdated}
                emptyRowsView={EmptyRowsView}
            />
        </div>
    );
}

export default DuChiCaNhanTable;
